import { Component, OnInit, inject, computed } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Page } from '../../../page/page';
import { strategicPlanmodulesRoutes } from './sp-module.routing';
import { MATERIAL_IMPORTS } from '../../../shared/shared-exports/material.exports';
import { CommonModule, Location } from '@angular/common';
import { Breadcrumb } from '../../../shared/components/breadcrumb/breadcrumb';
import { Sidebar } from '../../../shared/components/sidebar/sidebar';
import { filter } from 'rxjs';
import { AppStoreService } from '../../../store/ngrx-signal.store';
import { ENTITIES } from '../../../store/entities.registry';
import * as fromGraphql from '../strategic-plan.graphql';

@Component({
  selector: 'app-sp-module-view',
  standalone: true,
  imports: [RouterOutlet, Breadcrumb, Sidebar, ...MATERIAL_IMPORTS, CommonModule],
  templateUrl: './sp-module-view.html',
  styleUrl: './sp-module-view.scss',
})
export class SpModuleView implements OnInit {
  menuItems = strategicPlanmodulesRoutes;
  breadcrumbs: any = [];
  parentRoute: any;

  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly location = inject(Location);
  private readonly store = inject(AppStoreService);

  public readonly spDetails = this.store.entitySingleSignal<any>(ENTITIES.STRATEGIC_PLANS);

  defaultSpDetails = {
    name: 'eGA Five Year Rolling Strategic Plan 2021/22 - 2025/26',
    startDate: '2021-07-01',
    endDate: '2026-06-30',
    planType: '5 Year Plan',
    coverageLevel: 'Institutional',
    status: 'Active',
    institution: {
      name: 'e-Government Authority (eGA)',
      shortForm: 'eGA',
    },
  };

  displayedSpDetails = computed(() => {
    return this.spDetails() || this.defaultSpDetails;
  });

  ngOnInit(): void {
    if (this.route.routeConfig) {
      const { children, ...otherRouteAttributes } = this.route.routeConfig;
      this.parentRoute = otherRouteAttributes;
    }

    this.fetchSpDetails();
    this.adjustMenuItemsForContext();
    this.setAndUpdateBreadCrumbs();
  }

  private fetchSpDetails(): void {
    let currentRoute: ActivatedRoute | null = this.route;
    let spId: string | null = null;

    while (currentRoute) {
      if (currentRoute.snapshot.paramMap.has('spId')) {
        spId = currentRoute.snapshot.paramMap.get('spId');
        break;
      }
      currentRoute = currentRoute.firstChild;
    }

    if (spId) {
      this.store.query(ENTITIES.STRATEGIC_PLANS, fromGraphql.GET_STRATEGIC_PLAN, {
        filtering: { uniqueId: spId },
      });
    }
  }

  private adjustMenuItemsForContext(): void {
    const currentUrl = this.router.url;

    if (currentUrl.includes('/annual-plans') && !currentUrl.includes('/strategic-plans')) {
      this.menuItems = strategicPlanmodulesRoutes.map((item: any) => {
        if (item.path === 'annual-plans') {
          return { ...item, path: '/mne/annual-plans' };
        } else if (item.path !== 'annual-plans') {
          return { ...item, path: '/mne/strategic-plans' };
        }
        return item;
      });
    } else {
      this.menuItems = strategicPlanmodulesRoutes;
    }
  }

  goBack(): void {
    this.location.back();
  }

  async setAndUpdateBreadCrumbs() {
    this.breadcrumbs = await this.getBreadcrumbs(this.route);
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(async () => {
      this.breadcrumbs = await this.getBreadcrumbs(this.route);
      this.adjustMenuItemsForContext();
      this.fetchSpDetails();
    });
  }

  async getBreadcrumbs(route: ActivatedRoute): Promise<any> {
    const breadcrumbs: any[] = [];
    let currentRoute = route.root;
    let url = '';

    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
      const path = currentRoute.snapshot.url.map((s) => s.path).join('/');
      if (path) url += `/${path}`;
      const label = currentRoute?.routeConfig?.data?.['name'];

      if (label && label != breadcrumbs[breadcrumbs.length - 1]?.label) {
        breadcrumbs.push({ label, url });
      }
    }
    return breadcrumbs;
  }
}

